module.exports = __webpack_public_path__ + "img/map-tz.80b4a765.png";